<template>
  <div id="shop_list">
    <div class="bottombox">
      <Header ref="header" />
      
    </div>
    <!-- bottombox end -->
    <div class="box_top clearfix">
      <dl class="portrait">
        <dt><img :src="HeadUrl" /></dt>
        <dd>
          <span class="phone">{{ MobileNumber }}</span>
          <strong class="integral">{{ yyjf }}积分</strong>
        </dd>
      </dl>
    </div>
    <!-- box_top end -->
    <div class="main">
      <div class="screen">
        <div class="clearfix screen_1">
          <span class="icon_open" @click="iconOpen" v-if="screenup">展开</span>
          <span class="icon_shrink" @click="iconShrink" v-else>收起</span>
        </div>
        <div class="clearfix screen_2" :class="{ up: screenup }">
          <p>
            <strong>商品分类：</strong
            ><span
              ><a
                key="0"
                :class="{ side: sideTypt == 0 }"
                @click="sideTypts(1, 16, 0)"
                >不限</a
              >
              <a
                v-for="(item, index) in CourseType1"
                :key="item.Id"
                :class="{ side: sideTypt == item.Id }"
                @click="sideTypts(1, 16, item.Id)"
                >{{ item.Name }}</a
              >
              <a
                v-for="(item, index) in CourseType2"
                :key="item.Id"
                :class="{ side: sideTypt == item.Id }"
                @click="sideTypts(1, 16, item.Id)"
                >{{ item.Name }}</a
              ></span
            >
          </p>
        </div>
        <div class="clearfix screen_3">
          <strong>排序方式：</strong>
          <a :class="{ side: orderType == 1 }" @click="orderTypes(1, 16, 1)"
            >最新上架</a
          >
          <span>
            <a @click="orderTypes(1, 16, 2)"
              >价格<em
                ><i class="el-icon-caret-top"></i
                ><i class="el-icon-caret-bottom"></i></em
            ></a>
            <a :class="{ side: orderType == 2 }" @click="orderTypes(1, 16, 4)"
              >价格<em
                ><i class="el-icon-caret-top sideUp"></i
                ><i class="el-icon-caret-bottom"></i></em
            ></a>
            <a :class="{ side: orderType == 4 }" @click="orderTypes(1, 16, 2)"
              >价格<em
                ><i class="el-icon-caret-top"></i
                ><i class="el-icon-caret-bottom sideUp"></i></em
            ></a>
          </span>
        </div>
      </div>
      <!-- screen end -->
      <div class="main_list">
        <ul class="clearfix">
          <li v-for="(item, index) in shopList" :key="item.Id">
            <!-- <a :href="'/shop_details?shopId='+item.Id"> -->
            <router-link
              :to="{ path: 'shop_details', query: { shopId: item.Id } }"
            >
              <dl>
                <dt><img :src="item.CoverImg" width="100%" /></dt>
                <dd>
                  <h2>{{ item.Title }}</h2>
                  <p class="p0">价值：￥{{ item.Money }}</p>
                  <p class="p1">库存：{{ item.Extant }}</p>
                  <div class="p3">
                    <strong>{{ item.ConversionPrice }}积分</strong>
                  </div>
                </dd>
              </dl>
            </router-link>
            <!-- </a> -->
          </li>
        </ul>
      </div>
      <!-- main_list end -->
      <div class="block">
        <el-pagination
          @size-change="handleSizeChange"
          @current-change="handleCurrentChange"
          :current-page.sync="currentPage3"
          :page-size="pageSize"
          :total="count"
          background
          layout="total,prev, pager, next, jumper,->"
        >
        </el-pagination>
      </div>
      <!-- block end -->
    </div>
    <!-- main end -->
    <div class="yycg_tan" v-if="ljyycg">
      <img src="../../assets/publicClass/yycg_tan.png" width="272" />
      <h2>预约成功</h2>
      <p>
        课程动态我们会短信提醒您。<br />
        您可以到个人中心查询或取消该关注。
      </p>
      <span @click="closeTan">确定</span>
    </div>
    <!-- yycg_tan end -->
  </div>
</template>

<script>
import Header from "../../components/header/Header.vue"; //公共头部

export default {
  name: "App",
  components: {
    // 将组件隐射为标签,登陆弹窗
    Header,
    
  },
  metaInfo() {
    return {
      title: "积分商城",
      meta: [
        {
          name: "keywords",
          content:
            "启德考培在线积分商城,启德考培在线课程,雅思在线课程,托福在线课程",
        },
        {
          name: "description",
          content:
            "启德考培在线,启德考培旗下官方网校.启德考培教师团队,讲授托福在线课程、雅思在线课程等出国考试在线课程.",
        },
      ],
    };
  },
  data() {
    return {
      HeadUrl: "",
      MobileNumber: "手机号",
      yyjf: "",
      CourseType1: "",
      CourseType2: "",
      sideTypt: 0,
      orderType: 1,
      pageSize: 16,
      count: null,
      screenup: false,
      sideUp: 0,
      shopList: [],
      currentPage3: 1,
      ljyycg: false,
    };
  },
  methods: {
    iconShrink() {
      this.screenup = true;
    },
    iconOpen() {
      this.screenup = false;
    },
    sideTypts(page, limit, type) {
      var that = this;
      var url = this.$route.path;
      this.sideTypt = type;
      this.$router.push({
        path: url,
        query: {
          type: type,
          orderType: this.orderType,
        },
      });
      this.$http
        .get(
          "https://schoolapi.eiceducation.com.cn/api/Goods?page=" +
            page +
            "&limit=" +
            limit +
            "&type=" +
            type +
            "&orderType=" +
            this.orderType
        )
        .then(function (result) {
          // // console.log(result)
          that.shopList = result.data.results;
          that.count = result.data.count;
        })
        .catch(function (error) {
          // console.log(error);
        });
    },
    orderTypes(page, limit, orderType) {
      var that = this;
      var url = this.$route.path;
      this.orderType = orderType;
      this.$router.push({
        path: url,
        query: {
          type: this.sideTypt,
          orderType: orderType,
        },
      });
      this.$http
        .get(
          "https://schoolapi.eiceducation.com.cn/api/Goods?page=" +
            page +
            "&limit=" +
            limit +
            "&type=" +
            this.sideTypt +
            "&orderType=" +
            orderType
        )
        .then(function (result) {
          // // console.log(result)
          that.shopList = result.data.results;
          that.count = result.data.count;
        })
        .catch(function (error) {
          // console.log(error);
        });
    },
    handleSizeChange(val) {
      // console.log(`每页 ${val} 条`);
    },
    handleCurrentChange(val) {
      // console.log(`当前页: ${val}`);
      var that = this;
      var url = this.$route.path;
      this.pages = val;
      this.$router.push({
        path: url,
        query: {
          type: this.sideTypt,
          orderType: this.orderType,
          page: this.pages,
        },
      });

      this.$http
        .get(
          "https://schoolapi.eiceducation.com.cn/api/Goods?page=" +
            this.pages +
            "&limit=" +
            this.pageSize +
            "&type=" +
            this.sideTypt +
            "&orderType=" +
            this.orderType
        )
        .then(function (result) {
          // // console.log(result)
          that.shopList = result.data.results;
          that.count = result.data.count;
        })
        .catch(function (error) {
          // console.log(error);
        });
    },

    //加载登录后信息
    reloads() {
      var that = this;
      // 个人信息
      this.$http
        .get("https://schoolapi.eiceducation.com.cn/api/UserInfo", {
          headers: {
            token: this.$cookies.get("token"),
          },
        })
        .then(function (result) {
          // // console.log(result)
          that.yyjf = result.data.results.Integral;
          that.HeadUrl = result.data.results.HeadUrl;
          var tel = result.data.results.MobileNumber;
          var reg = /^(\d{3})\d{4}(\d{4})$/;
          tel = tel.replace(reg, "$1****$2");
          that.MobileNumber = tel;
           if (that.$cookies.get("token")) {
            that.$store.commit("setUserInfo", result.data.results);
          } else {
            that.$store.commit("setUserInfo", { Type: 1 });
          }
        })
        .catch(function (error) {
          // console.log(error);
          that.$message.error(error);
        });
    },
  },
  created: function () {
    let that = this;
    // 初始页面展示
    this.$http
      .get("https://schoolapi.eiceducation.com.cn/api/Enum?nameCode=GoodType")
      .then(function (result) {
        let ary = [];
        for (var i = 0; i < result.data.results.length; i++) {
          ary.push(result.data.results[i].List);
        }
        that.CourseType1 = ary[0];
        that.CourseType2 = ary[1];
      })
      .catch(function (error) {
        // console.log(error);
      });
    // 判断this.page是否为初始至
    if (this.$route.query.page) {
      this.page = this.$route.query.page;
    }
    // 判断this.limit是否为初始至
    if (this.$route.query.limit) {
      this.pageSize = this.$route.query.limit;
    }
    // 判断this.sideTypt是否为初始至
    if (this.$route.query.type) {
      this.sideTypt = this.$route.query.type;
    }
    // 判断this.sideTypt是否为初始至
    if (this.$route.query.orderType) {
      this.orderType = this.$route.query.orderType;
    }
    this.$http
      .get(
        "https://schoolapi.eiceducation.com.cn/api/Goods?page=" +
          that.page +
          "&limit=" +
          that.pageSize +
          "&type=" +
          that.sideTypt +
          "&orderType=" +
          that.orderType
      )
      .then(function (result) {
        // // console.log(result)
        that.shopList = result.data.results;
        that.count = result.data.count;
      })
      .catch(function (error) {
        // console.log(error);
      });
  },
  mounted: function () {
    //自动触发写入的函数
    let that = this;
    that.tokenkey = that.$cookies.get("token");
    if (!that.tokenkey) {
      that.$message.warning("请您登录后进行兑换！");
      return;
    }
    that.reloads();
  },
};
</script>

<style scoped>
.bottombox {
  box-shadow: 0px 3px 5px 0px rgba(233, 233, 233, 0.5);
  position: relative;
  z-index: 9;
}

.box_top {
  width: 100%;
  height: 88px;
  background: url(../../assets/teacher/topBJ.png) top no-repeat;
  padding-top: 40px;
  position: relative;
  display: flex;
  justify-content: center;
}

.box_top .portrait {
}

.box_top .portrait dt {
  border: 20px #f8f8f8 solid;
  width: 120px;
  height: 120px;
  overflow: hidden;
  background: #fff;
  border-radius: 80px;
  margin: 0 auto;
  background: url(../../assets/shopping/icon_my_photo.png) center no-repeat;
}

.box_top .portrait dt img {
  display: block;
  width: 100%;
}

.box_top .portrait dd {
  padding-top: 16px;
  text-align: center;
}

.box_top .portrait dd .phone {
  display: block;
  font-size: 32px;
  line-height: 48px;
  color: #333;
}

.box_top .portrait dd .integral {
  display: inline-block;
  line-height: 30px;
  text-align: center;
  font-size: 16px;
  color: #ff3250;
  font-weight: normal;
  margin-bottom: 8px;
  background: url(../../assets/shopping/icon_integral_1.png) left no-repeat;
  padding-left: 34px;
}

.screen {
  background: #fff;
  padding-top: 180px;
}

.screen_1 {
  width: 1180px;
  height: 66px;
  border-bottom: 1px #d5d5d5 solid;
  padding-top: 32px;
  box-sizing: border-box;
  margin: 0 auto;
  margin-bottom: 20px;
}

.screen_1 strong {
  display: block;
  font-size: 16px;
  color: #d5d5d5;
  line-height: 20px;
  float: left;
  font-weight: normal;
}

.screen_1 span {
  display: block;
  font-size: 14px;
  color: #666666;
  line-height: 20px;
  float: right;
  padding-right: 14px;
  background: url(../../assets/publicClass/icon_shrink.png) right no-repeat;
  cursor: pointer;
}

.screen_1 .icon_open {
  background: url(../../assets/publicClass/icon_open.png) right no-repeat;
}

.screen_2 {
  width: 1180px;
  margin: 0 auto;
  box-sizing: border-box;
  border-bottom: 1px #d5d5d5 solid;
  margin-bottom: 20px;
}

.screen_2.up {
  display: none;
}

.screen_2 p {
  margin-bottom: 15px;
  text-align: left;
  display: table;
}

.screen_2 p strong {
  display: inline-block;
  font-size: 14px;
  line-height: 36px;
  color: #999;
  margin-right: 24px;
  float: left;
}

.screen_2 p span {
  display: inline-block;
  width: 1080px;
  float: left;
}

.screen_2 p a {
  display: inline-block;
  min-width: 82px;
  height: 36px;
  font-size: 14px;
  line-height: 36px;
  border-radius: 18px;
  margin-right: 10px;
  color: #333333;
  text-align: center;
  cursor: pointer;
  padding: 0 20px;
  box-sizing: border-box;
  transition: all 0.25s ease-in;
  -moz-transition: all 0.25s ease-in;
  -webkit-transition: all 0.25s ease-in;
}

.screen_2 p a:hover {
  color: #4e5cf6;
}

.screen_2 p a.side {
  background: #f8f8f8;
  color: #4e5cf6;
}

.screen_3 {
  width: 1180px;
  padding-bottom: 20px;
  margin: 0 auto;
  box-sizing: border-box;
  text-align: left;
}

.screen_3 strong {
  display: inline-block;
  font-size: 14px;
  line-height: 36px;
  color: #999;
  margin-right: 24px;
  float: left;
}

.screen_3 a {
  display: inline-block;
  min-width: 82px;
  height: 36px;
  font-size: 14px;
  line-height: 36px;
  border-radius: 18px;
  margin-right: 10px;
  color: #333333;
  text-align: center;
  cursor: pointer;
  padding: 0 13px;
  box-sizing: border-box;
  float: left;
}

.screen_3 a.side {
  background: #f8f8f8;
}

.screen_3 a.side em .sideUp {
  color: #4e5cf6;
}

.screen_3 a em {
  width: 14px;
  height: 18px;
  display: inline-block;
  position: relative;
  float: right;
  vertical-align: top;
  margin-top: 10px;
}

.screen_3 a em i {
  display: block;
  position: absolute;
  left: 0;
  font-size: 12px;
  color: #d8d8d8;
}

.screen_3 a em .el-icon-caret-top {
  top: 0;
}

.screen_3 a em .el-icon-caret-bottom {
  bottom: 0;
}

.screen_3 a.side-up em .el-icon-caret-bottom {
  color: #999;
}

.screen_3 a.side-down em .el-icon-caret-top {
  color: #999;
}

.screen_3 span {
  float: left;
  font-size: 14px;
  color: #333;
  line-height: 36px;
  position: relative;
}

.screen_3 span a {
  position: absolute;
  left: 0;
  top: 0;
}

.screen_3 span .side {
  z-index: 7;
}

.main {
  background: #fafafa;
  padding-bottom: 70px;
}

.main_list {
  width: 1180px;
  margin: 0 auto;
}

.main_list ul {
  padding-top: 24px;
  padding-bottom: 32px;
}

.main_list ul li {
  width: 280px;
  height: 412px;
  float: left;
  background: #ffffff;
  box-shadow: 0px 0px 10px 6px rgba(245, 246, 246, 0.2);
  border-radius: 8px;
  overflow: hidden;
  margin-right: 20px;
  margin-bottom: 20px;
  transition: all 0.25s ease-in;
  -moz-transition: all 0.25s ease-in;
  -webkit-transition: all 0.25s ease-in;
  position: relative;
}

.main_list ul li:hover {
  box-shadow: 0px 0px 10px 6px #f5f6f6;
  transform: translateY(-4px);
}

.main_list ul li:nth-child(4n) {
  margin-right: 0;
}

.main_list ul li dt {
  width: 280px;
  height: 280px;
  overflow: hidden;
}

.main_list ul li dd {
  padding: 0 16px;
  padding-top: 12px;
  text-align: left;
}

.main_list ul li dd h2 {
  font-size: 16px;
  color: #333;
  line-height: 22px;
  margin-bottom: 8px;
  font-weight: normal;
  display: -webkit-box;
  -webkit-box-orient: vertical;
  -webkit-line-clamp: 2;
  overflow: hidden;
}

.main_list ul li dd .p0 {
  font-size: 12px;
  color: #666;
  line-height: 12px;
  margin-bottom: 8px;
}

.main_list ul li dd .p1 {
  font-size: 12px;
  color: #666;
  line-height: 12px;
}

.main_list ul li dd .p3 strong {
  font-size: 20px;
  float: right;
  line-height: 20px;
  color: #333;
}

.block {
  width: 1180px;
  text-align: right;
  margin: 0 auto;
}
</style>



// WEBPACK FOOTER //
// src/page2/shopping/shop_list.vue